import { Box, IconButton } from '@mui/material';
import {
	gridDetailPanelExpandedRowsContentCacheSelector,
	useGridApiContext,
	useGridSelector,
} from '@mui/x-data-grid-pro';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';
import HijackedFlagCard from './HijackedFlagCard';
import CatalogFlagCard from './CatalogFlagCard';
import ErrorFlagCard from './ErrorFlagCard';

export default function CustomDetailPanelToggle(props) {
	const { id, value: isExpanded } = props;
	const apiRef = useGridApiContext();

	// To avoid calling ´getDetailPanelContent` all the time, the following selector
	// gives an object with the detail panel content for each row id.
	const contentCache = useGridSelector(
		apiRef,
		gridDetailPanelExpandedRowsContentCacheSelector
	);

	// If the value is not a valid React element, it means that the row has no detail panel.
	const hasDetail = React.isValidElement(contentCache[id]);

	const hasCatalog = props?.row?.catalogflag;
	const isHijacked = props?.row?.hijacked;
	const hasError = props?.row?.shippingflag;

	const statusClassName =
		(hasCatalog && isHijacked) || hasError
			? 'triangle-top-left-error'
			: hasCatalog
			? 'triangle-top-left-cat'
			: '';

	return (
		<Box
			sx={{
				position: 'relative',
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: '0',
					left: '0',
				}}
			>
				{hasCatalog && isHijacked ? (
					<HijackedFlagCard seller={props?.row?.hijackedseller}>
						<Box className={statusClassName} />
					</HijackedFlagCard>
				) : hasCatalog ? (
					<CatalogFlagCard link={props?.row?.permalink}>
						<Box className={statusClassName} />
					</CatalogFlagCard>
				) : hasError ? (
					<ErrorFlagCard>
						<Box className={statusClassName} />
					</ErrorFlagCard>
				) : null}
			</Box>

			{hasCatalog && hasError && (
				<Box
					sx={{
						position: 'absolute',
						bottom: '0',
						left: '0',
					}}
				>
					<ErrorFlagCard>
						<Box className="triangle-bottom-left-error" />
					</ErrorFlagCard>
				</Box>
			)}
			<IconButton
				size="small"
				tabIndex={-1}
				disabled={!hasDetail}
				aria-label={isExpanded ? 'Close' : 'Open'}
			>
				<ArrowDropDownIcon
					sx={{
						transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
						transition: (theme) =>
							theme.transitions.create('transform', {
								duration: theme.transitions.duration.shortest,
							}),
						width: '24px',
						height: '24px',
					}}
					fontSize="inherit"
				/>
			</IconButton>
		</Box>
	);
}
